import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  Offcanvas,
  Tabs,
  Tab,
  Button,
} from "react-bootstrap";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { MdOutlineClose } from "react-icons/md";
import API_DOMAIN from "../config/config";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment/moment";
import "react-toastify/dist/ReactToastify.css";
import { FaMagnifyingGlass } from "react-icons/fa6";

import { generateSalesPartyPdf } from "./salespartyPDF";
import jsPDF from "jspdf";
import "jspdf-autotable";

export function calculateTotals(transactions, openingBalance = 0) {
  let totalPaid = 0;
  let totalBalance = parseFloat(openingBalance) || 0;

  transactions.forEach((transaction) => {
    const paid = parseFloat(transaction.paid || 0);
    const balance = parseFloat(transaction.balance || 0);

    totalPaid += paid;

    if (transaction.type === "Payin") {
      totalBalance -= paid; // You received money → reduces outstanding
    } else {
      totalBalance += balance; // Invoice / Debit → increases outstanding
    }
  });

  return {
    paid: totalPaid.toFixed(2),
    balance: totalBalance.toFixed(2),
  };
}
const ProductHistory = [
  "S.No",
  "Date",
  "Receipt No",
  "amount",
  "Paid",
  "Payment Method",
  "Balance",
  "Details",
];
const BalanceSheetHeaders = [
  "Date",
  "Particulars",
  "Credit",
  "Debit",
  "Balance",
  "Action",
];

const DummyTablehead = ["Name", "Status"];

const Party = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [Limit, SetLimit] = useState();
  const [show, setShow] = useState(false);
  const [openFilter, setFilter] = useState(false);
  const handleClose = () => {
    setShow(false);
    location.state = [];
  };
  const handleShow = () => {
    setCrtSales(null);
    setFormData({
      party_id: "",
      party_name: "",
      mobile_number: "",
      alter_number: "",
      email: "",
      state: "",
      city: "",
      company_name: "",
      gst_no: "",
      billing_address: "",
      shipp_address: "",
      opening_balance: "",
      opening_date: "",
      ac_type: "",
    });
    setShow(true);
  };
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const [clickedData, setClickedData] = useState(null);
  console.log("Clicked Data:", clickedData);

  const [resetKey, setResetKey] = useState(0);
  const handleClick = (data) => {
    data.transactions?.sort((a, b) => new Date(b.date) - new Date(a.date));
    data.party_wise_balance_sheet_report?.sort(
      (a, b) => new Date(b.Date) - new Date(a.Date)
    );

    setClickedData(data);
    setFromDate("");
    setToDate("");
    setResetKey((prev) => prev + 1);
  };

  const [crtSales, setCrtSales] = useState(null);
  const handleEditClick = (rowdata) => {
    setCrtSales(rowdata);
    setShow(true);
  };
  const [formData, setFormData] = useState({
    party_id: "",
    party_name: "",
    mobile_number: "",
    alter_number: "",
    email: "",
    city: "",
    state: "",
    company_name: "",
    gst_no: "",
    billing_address: "",
    shipp_address: "",
    opening_balance: "",
    opening_date: "",
    ac_type: "",
  });
  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtSales != null) {
      setCrtSales({
        ...crtSales,
        [fieldName]: value,
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };
  const [from_date, setFromDate] = useState(""); // Set to empty string
  const [to_date, setToDate] = useState("");

  const setDateLabel = (value, field) => {
    if (field === "from_date") {
      setFromDate(moment(value).format("YYYY-MM-DD"));
    } else if (field === "to_date") {
      setToDate(moment(value).format("YYYY-MM-DD"));
    }
  };

  const handleClearDates = () => {
    setFromDate("");
    setToDate("");
    setResetKey((prevKey) => prevKey + 1);
  };

  const [searchText, setSearchText] = useState("");
  const handleSearch = (value) => {
    setSearchText(value);
    //
  };
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const fetchData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: searchText,
          company_id: companyId,
          from_date: from_date,
          to_date: to_date,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      setLoading(false);
      if (responseData.code === 200) {
        setUserData(responseData.data);
        if (responseData.data.length > 0) {
          setClickedData(responseData.data[0]);
        }
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initialFetch = async () => {
      try {
        const companyId = localStorage.getItem("companyId");
        const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: searchText,
            company_id: companyId,
            from_date: "",
            to_date: "",
          }),
        });
        const responseData = await response.json();
        setLoading(false);
        if (responseData.code === 200) {
          setUserData(responseData.data);
          if (responseData.data.length > 0) {
            setClickedData(responseData.data[0]);
          }
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    initialFetch();
  }, []);

  useEffect(() => {
    fetchData();
  }, [searchText, from_date, to_date]);

  const [showAlert, setShowAlert] = useState(false);
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const handleSubmit = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_id: companyId,
          party_name: formData.party_name,
          mobile_number: formData.mobile_number,
          alter_number: formData.alter_number,
          email: formData.email,
          company_name: formData.company_name,
          gst_no: formData.gst_no,
          billing_address: formData.billing_address,
          shipp_address: formData.shipp_address,
          opening_balance: formData.opening_balance,
          opening_date: formData.opening_date,
          ac_type: formData.ac_type,
          city: formData.city,
          state: formData.state,
        }),
      });

      const responseData = await response.json();

      if (responseData.code === 200) {
        successAlert(responseData.msg);
        setTimeout(() => {
          fetchData();
          handleClose();
          window.location.reload();
        }, 2000);
      } else if (responseData.code === 400) {
        toast.error("Missing required fields!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setShowAlert(true);
      }
    } catch (error) {}
  };
  const handleUpdateSubmit = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_id: companyId,
          edit_party_id: crtSales.party_id,
          party_name: crtSales.party_name,
          mobile_number: crtSales.mobile_number,
          alter_number: crtSales.alter_number,
          email: crtSales.email,
          city: crtSales.city,
          state: crtSales.state,
          company_name: crtSales.company_name,
          gst_no: crtSales.gst_no,
          billing_address: crtSales.billing_address,
          shipp_address: crtSales.shipp_address,
          opening_balance: crtSales.opening_balance,
          opening_date: crtSales.opening_date,
          ac_type: crtSales.ac_type,
        }),
      });

      const responseData = await response.json();

      if (responseData.code === 200) {
        successAlert(responseData.msg);
        setTimeout(() => {
          fetchData();
          handleClose();
          window.location.reload();
        }, 2000);

        // Navigate to the user list page after a delay
      } else {
      }
    } catch (error) {}

    setLoading(false);
  };

  const sendWhatsAppStatement = async () => {
    console.log("Clicked Data for WhatsApp:");
    if (!clickedData || !clickedData.mobile_number) {
      toast.error("Mobile number not available!");
      return;
    }

    try {
      // Create a copy and sort descending to ensure we get the latest entry at [0]
      const balanceSheet = [
        ...(clickedData.party_wise_balance_sheet_report || []),
      ].sort((a, b) => new Date(b.Date) - new Date(a.Date));

      const words = clickedData.party_name.trim().split(/\s+/);
      let shortName = words.map((w) => w[0].toUpperCase()).join("");
      if (shortName.length > 3) shortName = shortName.slice(0, 3);

      const latestRow = balanceSheet.length > 0 ? balanceSheet[0] : null;

      let displayValue = 0;
      let latestParticulars = "No transactions yet";
      let isLatestPayin = false;
      let isLatestInvoice = false;

      if (latestRow) {
        const debit = parseFloat(latestRow.Debit || 0);
        const credit = parseFloat(latestRow.Credit || 0);

        if (credit > 0) {
          displayValue = credit;
          isLatestPayin = true;
        } else if (debit > 0) {
          displayValue = debit;
          isLatestInvoice = true;
        }

        latestParticulars = latestRow.Particulars || "";
      }

      const finalBalance =
        balanceSheet.length > 0
          ? parseFloat(balanceSheet[0].Balance || 0)
          : 0;

      const now = moment().format("DD MMM YY · hh:mm A");

      // Canvas setup (matching jsPDF size ~160mm x 90mm at 96 DPI)
      const mmToPx = 96 / 25.4;
      const canvasWidth = 160 * mmToPx;
      const canvasHeight = 90 * mmToPx;

      const canvas = document.createElement("canvas");
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext("2d");

      // White background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvasWidth, canvasHeight);

      let y = 5 * mmToPx;

      // Blue circle with initials
      ctx.fillStyle = "rgb(30, 144, 255)";
      ctx.beginPath();
      ctx.arc(12 * mmToPx, y + 10 * mmToPx, 9 * mmToPx, 0, Math.PI * 2);
      ctx.fill();

      ctx.fillStyle = "#ffffff";
      ctx.font = "bold 12px Helvetica";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(shortName, 12 * mmToPx, y + 11.5 * mmToPx);

      // Party name
      ctx.fillStyle = "#000000";
      ctx.font = "18px Helvetica";
      ctx.textAlign = "start";
      ctx.textBaseline = "top";
      let displayName = clickedData.party_name.trim();
      if (ctx.measureText(displayName).width > canvasWidth - 80 * mmToPx) {
        displayName = displayName.substring(0, 22) + "...";
      }
      ctx.fillText(displayName, 25 * mmToPx, y + 8 * mmToPx);

      // Display transaction value (Debit or Credit)
      ctx.font = "20px Helvetica";
      let creditText = "Rs. 0";

      if (isLatestPayin) {
        ctx.fillStyle = "rgb(0,128,0)";
        creditText = "Rs. " + displayValue.toLocaleString("en-IN");
      } else if (isLatestInvoice) {
        ctx.fillStyle = "rgb(255,0,0)";
        creditText = "Rs. " + displayValue.toLocaleString("en-IN");
      }

      const creditWidth = ctx.measureText(creditText).width;
      ctx.fillText(
        creditText,
        canvasWidth - 10 * mmToPx - creditWidth,
        y + 8 * mmToPx
      );

      // Date/time and message
      ctx.font = "13px Helvetica";
      ctx.fillStyle = "rgb(100,100,100)";
      ctx.fillText(now, 25 * mmToPx, y + 16 * mmToPx);

      const youGotText = isLatestPayin
        ? "You got"
        : isLatestInvoice
        ? "You gave"
        : "";
      if (youGotText) {
        const youGotWidth = ctx.measureText(youGotText).width;
        ctx.fillText(
          youGotText,
          canvasWidth - 10 * mmToPx - youGotWidth,
          y + 16 * mmToPx
        );
      }

      y += 22 * mmToPx;

      // Horizontal line
      ctx.strokeStyle = "rgb(230,230,230)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(3 * mmToPx, y);
      ctx.lineTo(canvasWidth - 3 * mmToPx, y);
      ctx.stroke();

      y += 8 * mmToPx;

      // "Details"
      ctx.font = "14px Helvetica";
      ctx.fillStyle = "rgb(100,100,100)";
      ctx.fillText("Details", 8 * mmToPx, y);

      y += 10 * mmToPx;

      // Particulars
      ctx.font = "bold 16px Helvetica";
      ctx.fillStyle = "#000000";
      let cleanParticulars = latestParticulars
        ? latestParticulars.replace(/(.+)\1+$/, "$1").trim()
        : "";
      ctx.fillText(cleanParticulars, 8 * mmToPx, y, canvasWidth - 16 * mmToPx);

      y += 8 * mmToPx;

      // Second horizontal line
      ctx.beginPath();
      ctx.moveTo(3 * mmToPx, y);
      ctx.lineTo(canvasWidth - 3 * mmToPx, y);
      ctx.stroke();

      y += 15 * mmToPx;

      // "Running Balance"
      ctx.font = "16px Helvetica";
      ctx.fillStyle = "rgb(100,100,100)";
      ctx.fillText("Running Balance", 8 * mmToPx, y);

      const balanceAbs = Math.abs(finalBalance).toLocaleString("en-IN");
      const balanceText =
        finalBalance < 0 ? `Rs. - ${balanceAbs}` : `Rs. ${balanceAbs}`;

      ctx.font = "24px Helvetica";
      ctx.fillStyle = finalBalance < 0 ? "rgb(255,0,0)" : "rgb(0,128,0)";
      const balanceWidth = ctx.measureText(balanceText).width;
      ctx.fillText(balanceText, canvasWidth - 10 * mmToPx - balanceWidth, y);

      // Convert canvas to PNG blob
      const pngBlob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png", 1)
      );

      const fileName = `${clickedData.party_name
        .replace(/[^a-zA-Z0-9]/g, "_")
        .substring(0, 50)}_Statement.png`;
      const file = new File([pngBlob], fileName, { type: "image/png" });

      const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(
        navigator.userAgent
      );

      if (
        isMobile &&
        navigator.canShare &&
        navigator.canShare({ files: [file] })
      ) {
        try {
          await navigator.share({ files: [file] });
          toast.success("Statement shared successfully!");
          return;
        } catch (err) {
          if (err.name !== "AbortError") {
            console.error(err);
            toast.error("Sharing failed.");
          }
        }
      }

      // Fallback: download
      toast.info("Direct share not available. Downloading image...");
      const link = document.createElement("a");
      link.href = URL.createObjectURL(pngBlob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to generate or share statement.");
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Get total values and assign to clickedData
  const clickedDatapaidbalanlce = calculateTotals(
    clickedData ? clickedData.transactions : [],
    clickedData?.opening_balance || 0
  );

  const generatePdf = () => {
    generateSalesPartyPdf(clickedData, errorAlert, from_date, to_date);
  };

  if (loading) {
    return <LoadingSpinner message="Loading Sales Party..." height="300px" />;
  }
  const sortedTransactions = (clickedData?.transactions || []).sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const originalBalanceSheet =
    clickedData?.party_wise_balance_sheet_report || [];
  const openingBalanceValue = parseFloat(clickedData?.opening_balance || 0);
  const openingDate =
    clickedData?.opening_date || moment().format("YYYY-MM-DD"); // Fallback to today if no opening date

  // 1. Sort ascending first to calculate running balances correctly
  let sortedBalanceSheetWithOpening = originalBalanceSheet.sort(
    (a, b) => new Date(a.Date) - new Date(b.Date)
  );

  // 2. Add opening balance if needed
  const isOpeningAlreadyIncluded =
    sortedBalanceSheetWithOpening.length > 0 &&
    sortedBalanceSheetWithOpening[0].Particulars?.toLowerCase().includes("opening") &&
    parseFloat(sortedBalanceSheetWithOpening[0].Balance || 0) === openingBalanceValue;

  if (openingBalanceValue !== 0 && !isOpeningAlreadyIncluded) {
    const openingRow = {
      Date: openingDate,
      Particulars: "Opening Balance",
      Credit: 0,
      Debit: openingBalanceValue > 0 ? openingBalanceValue : 0, 
      Balance: openingBalanceValue,
    };

    if (sortedBalanceSheetWithOpening.length === 0) {
      sortedBalanceSheetWithOpening = [openingRow];
    } else {
      sortedBalanceSheetWithOpening.unshift(openingRow);
    }
  }

  // 3. Calculate running balances chronologically (Ascending order)
  let cumulativeBalance = openingBalanceValue !== 0 && !isOpeningAlreadyIncluded 
      ? openingBalanceValue 
      : 0; 
      
  // If opening balance was already in the data, set initial cumulative to specific starting point if needed, 
  // but typically 'unshift' handles the start. If 'isOpeningAlreadyIncluded' is true, 
  // we might need to be careful not to double count, but the logic below iterates.
  // Actually, let's just recalculate strictly from top to bottom.
  
  // Re-establish cumulative balance from the very first item (which is now confirmed to be opening balance if exists)
  if(sortedBalanceSheetWithOpening.length > 0) {
      // The first item *is* the starting balance state effectively.
      // If we added an opening row, its balance is set.
      // If we didn't add it (because it existed or was 0), we start accumulating.
      
      // Let's iterate and enforce the math: Balance = PrevBalance + Debit - Credit
      let running = 0;
      
      sortedBalanceSheetWithOpening.forEach((row, index) => {
        const credit = parseFloat(row.Credit || 0);
        const debit = parseFloat(row.Debit || 0);
        
        if (index === 0) {
             // For the very first row (oldest), the Balance is just Debit - Credit (or just its value if it's opening)
             // If it's the injected opening row, Balance is already set correctly.
             // If it's a transaction, it starts from 0 (or strictly speaking, opening balance should have been there).
             if(row.Particulars === "Opening Balance") {
                 running = parseFloat(row.Balance); 
             } else {
                 // No opening balance row exists, so start from 0 + this transaction
                 // But wait, if openingBalanceValue was 0, running starts at 0.
                 // If openingBalanceValue existed but we didn't inject (because isOpeningAlreadyIncluded?), 
                 // then row.Balance should be trusted? No, usually we recalculate to be safe.
                 running = debit - credit;
                 row.Balance = running;
             }
        } else {
             running = running + debit - credit;
             row.Balance = running;
        }
      });
  }

  // 4. Filter out "Opening Balance" row for display if desired (user request usually implies showing transactions)
  // The original code filtered it out:
  const sortedBalanceSheetWithOpeningFiltered = sortedBalanceSheetWithOpening.filter(
      (row) => row.Particulars?.toLowerCase() !== "opening balance"
  );

  // 5. Finally, reverse to Descending Order for display
  const sortedBalanceSheet = sortedBalanceSheetWithOpeningFiltered.reverse();

  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg="4" className="py-1">
            <div className="main my-2">
              <Row>
                <Col lg="7">
                  <div className="mx-2">
                    <TextInputForm
                      placeholder={"Name"}
                      onChange={(e) => handleSearch(e.target.value)}
                      prefix_icon={<FaMagnifyingGlass />}
                      labelname={"Search"}
                    >
                      {" "}
                    </TextInputForm>
                  </div>
                </Col>
                <Col
                  lg="5"
                  className="align-item-baseline d-flex justify-content-end"
                >
                  <div>
                    <Buttons lable={<> Add New</>} onClick={handleShow} />
                  </div>
                </Col>
              </Row>

              <div className="py-2 c-table">
                <TableUI
                  headers={DummyTablehead}
                  body={userData}
                  type="partysales"
                  handleEditClick={handleEditClick}
                  onClick={handleClick}
                  onDelete={fetchData}
                  pageview={"yes"}
                />
              </div>
            </div>
          </Col>
          <Col lg="8">
            <div className="my-2">
              <div className="main">
                {clickedData && (
                  <div>
                    <div className="d-flex justify-content-between mb-2">
                      <div>Name : {clickedData.party_name}</div>
                      <div>
                        <span>MobileNumber : {clickedData.mobile_number}</span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        <span>Total Paid : {clickedDatapaidbalanlce.paid}</span>
                      </div>
                      <div>
                        <span>
                          Total Balance : {clickedDatapaidbalanlce.balance}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="my-2">
              <div className="main">
                <>
                  <Row className="mx-2">
                    <Col xs={12}>
                      <PageTitle PageTitle={<>SALES PARTY SUMMARY DETAILS</>} />
                    </Col>
                  </Row>
                  <Row className="mx-2 mt-1 align-items-start">
                    <Col xs={0} lg={4}></Col>
                    <Col
                      xs={12}
                      lg={4}
                      className="d-flex justify-content-start mb-2 mb-lg-0"
                      style={{ marginTop: "-29px" }}
                    >
                      <div className="d-flex justify-content-start w-100 w-lg-autox">
                        <div
                          className="me-2"
                          style={{
                            width: "150px",
                            marginRight: "20px",
                            margintop: "-20px",
                          }}
                        >
                          <Calender
                            labelname={<>From</>}
                            key={resetKey}
                            value={from_date ? moment(from_date).toDate() : ""}
                            setLabel={(value) =>
                              setDateLabel(value, "from_date")
                            }
                          />
                        </div>
                        <div style={{ width: "150px" }}>
                          <Calender
                            labelname={<>To</>}
                            key={resetKey}
                            value={to_date ? moment(to_date).toDate() : ""}
                            setLabel={(value) => setDateLabel(value, "to_date")}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col
                      xs={12}
                      lg={4}
                      className="d-flex justify-content-end mb-2 mb-lg-0"
                    >
                      <div className="d-flex justify-content-end w-100 w-lg-auto">
                        <div className="me-2">
                          <Buttons
                            lable={<>Clear</>}
                            onClick={handleClearDates}
                            className="btn-sm"
                          />
                        </div>
                        <div>
                          <Buttons
                            lable={<>Download PDF</>}
                            onClick={generatePdf}
                            className="btn-sm"
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
                <Offcanvas
                  show={openFilter}
                  onHide={closeFilter}
                  placement="end"
                >
                  <Offcanvas.Body>
                    <Row>
                      <Col lg="6">
                        <PageTitle PageTitle={<>Sale Party</>} />
                      </Col>
                      <Col lg="6" className="align-self-center">
                        <div className="text-end">
                          <Buttons
                            onClick={closeFilter}
                            lable={
                              <>
                                <MdOutlineClose />
                              </>
                            }
                          ></Buttons>
                        </div>
                      </Col>
                    </Row>
                    <div className="py-3">
                      <TextInputForm labelname={<>Invoice No.</>} />
                    </div>
                    <div className="py-3">
                      <DropDownUI labelname={"Select Sale Party"} />
                    </div>
                    <div className="py-3">
                      <DropDownUI labelname={" Select Type"} />
                    </div>
                    <Row>
                      <Col lg="6" className="align-self-center">
                        <div>
                          <Calender labelname={<>From</>} />
                        </div>
                      </Col>
                      <Col lg="6" className="align-self-center">
                        <div>
                          <Calender labelname={<>To</>} />
                        </div>
                      </Col>
                      <Col lg="6" className="align-self-center">
                        <div className="my-5 text-center">
                          <Buttons lable={"Apply"}></Buttons>
                        </div>
                      </Col>
                      <Col lg="6" className="align-self-center">
                        <div className="my-5 text-center">
                          <Buttons lable={"Clear"}></Buttons>
                        </div>
                      </Col>
                    </Row>
                  </Offcanvas.Body>
                </Offcanvas>
                <Tabs defaultActiveKey="balancesheet" className="mt-3">
                  {/* TAB 1: TRANSACTIONS */}
                  <Tab eventKey="transactions" title="Transactions">
                    <div className="py-2 c-table table-scroll">
                      <TableUI
                        headers={ProductHistory}
                        body={sortedTransactions}
                        type="partysalestransactions"
                        pageview={"yes"}
                      />
                    </div>
                  </Tab>

                  {/* TAB 2: BALANCE SHEET */}
                  <Tab eventKey="balancesheet" title="Balance Sheet">
                    <div className="py-2 c-table table-scroll">
                      <TableUI
                        headers={BalanceSheetHeaders}
                        body={sortedBalanceSheet}
                        type="partysalesbalancesheet"
                        pageview={"yes"}
                        onWhatsAppSend={sendWhatsAppStatement} // ← This triggers the PDF
                      />
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <>
        <Modal show={show} onHide={handleClose} centered size="lg">
          <Modal.Header>
            <PageHead pagehead={<>Sales Party</>} onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg="4" className="py-3">
                  <TextInputForm
                    placeholder={"Company Name"}
                    labelname={"Company Name"}
                    name="party_name"
                    value={
                      crtSales != null
                        ? crtSales.party_name
                        : formData.party_name
                    }
                    onChange={(e) => handleChange(e, "party_name")}
                  />
                </Col>
                <Col lg="4" className="py-3">
                  <TextInputForm
                    placeholder={"Mobile Number"}
                    labelname={"Mobile Number"}
                    name="mobile_number"
                    value={
                      crtSales != null
                        ? crtSales.mobile_number
                        : formData.mobile_number
                    }
                    onChange={(e) => handleChange(e, "mobile_number")}
                  />
                </Col>
                <Col lg="4" className="py-3">
                  <TextInputForm
                    placeholder={"GST NO"}
                    labelname={"GST NO"}
                    name="gst_no"
                    value={crtSales != null ? crtSales.gst_no : formData.gst_no}
                    onChange={(e) => handleChange(e, "gst_no")}
                  />
                </Col>
                <Col lg="6" className="py-3">
                  <label className="pb-2">Billing Address</label>
                  <textarea
                    className="form-cntrl form-control"
                    placeholder={"Address"}
                    labelname={"Address"}
                    name="billing_address "
                    value={
                      crtSales != null
                        ? crtSales.billing_address
                        : formData.billing_address
                    }
                    onChange={(e) => handleChange(e, "billing_address")}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center py-4">
              {crtSales != null ? (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <ClickButton
                      label={<>Update</>}
                      onClick={handleUpdateSubmit}
                    ></ClickButton>
                  </span>

                  <span className="mx-2">
                    <ClickButton
                      label={<>Cancel</>}
                      onClick={() => {
                        handleClose();
                      }}
                    ></ClickButton>
                  </span>
                </>
              ) : (
                <>
                  <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <span className="mx-2">
                    <ClickButton
                      label={<>Submit</>}
                      onClick={handleSubmit}
                    ></ClickButton>
                  </span>

                  <span className="mx-2">
                    <ClickButton
                      label={<>Cancel</>}
                      onClick={() => {
                        handleClose();
                      }}
                    ></ClickButton>
                  </span>
                </>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
};

export default Party;
